
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"148.092","height":"110.76"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-301.96 -253.987)"}},[_c('rect',{attrs:{"width":"48.091","height":"15.333","rx":"7.667","transform":"translate(352.667 327.03)","fill":"#f9487f"}}),_c('rect',{attrs:{"width":"5.091","height":"5.333","rx":"2.545","transform":"translate(428.667 265.03)","fill":"#f9487f"}}),_c('rect',{attrs:{"width":"36.58","height":"7.051","rx":"2.091","transform":"translate(358.863 292.051)","fill":"#e8ebf0"}}),_c('rect',{attrs:{"width":"74.482","height":"5.289","rx":"1.394","transform":"translate(339.471 304.391)","fill":"#e8ebf0"}}),_c('rect',{attrs:{"width":"50.683","height":"5.289","rx":"1.394","transform":"translate(351.371 313.206)","fill":"#e8ebf0"}})]),_c('path',{attrs:{"d":"M135.89 0h-8.544L12.202.4a12.216 12.216 0 00-12.2 12.2v85.959a12.216 12.216 0 0012.2 12.2l123.689-.4a12.216 12.216 0 0012.2-12.2V12.202A12.216 12.216 0 00135.89 0zM4.88 12.6a7.329 7.329 0 017.321-7.321l115.144-.4h8.544a7.329 7.329 0 017.321 7.321v11.225l-138.33.4zm138.33 85.562a7.329 7.329 0 01-7.321 7.321l-123.689.4a7.329 7.329 0 01-7.321-7.321V28.705l138.33-.4v69.853z","fill":"#eceef2"}})])
          )
        }
      }
    